/**
 * created by lei lei
 * 选择来源
 */
import React, {Component} from 'react';
import { Checkbox,Modal,Input} from 'antd'
const plainOptions = ['测试1', '测试2', '测试3'];
export default class selectSource extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sourceTitleList: [],
            searchContent:''
        };
    }

    render() {
        const {visible,handleOk,handleCancel} = this.props;
        const {sourceTitleList,searchContent} = this.state;

        const showList = plainOptions.filter(item=>item.includes(searchContent))

        return (
            <Modal
                title="选择来源"
                visible={visible}
                onOk={()=>handleOk(sourceTitleList)}
                onCancel={handleCancel}
            >
                <div><Input placeholder="请输入搜索内容" value={searchContent} onChange={e=>this.setState({searchContent:e.target.value}) }></Input></div>
                <Checkbox.Group options={showList} value={sourceTitleList} onChange={checkedValues => this.checkboxonChange(checkedValues)}></Checkbox.Group>
            </Modal>
        );
    }
    checkboxonChange(checkedValues) {
        this.setState({
            sourceTitleList: checkedValues
        })
    }
}